import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/_core/shared.module";

// Components
import { DsAutocompleteComponent } from "./components/ds-autocomplete/ds-autocomplete.component";
import { DsSelectComponent } from "./components/ds-select/ds-select.component";
import { DsToggleComponent } from "./components/ds-toggle/ds-toggle.component";
import { DsDateComponent } from "./components/ds-date/ds-date.component";
import { DsTextareaComponent } from "./components/ds-textarea/ds-textarea.component";
import { DsRadioComponent } from "./components/ds-radio/ds-radio.component";
import { DsCheckboxComponent } from "./components/ds-checkbox/ds-checkbox.component";
import { DsSliderComponent } from "./components/ds-slider/ds-slider.component";
import { EmpleadoAvatarComponent } from "./components/empleado-avatar/empleado-avatar.component";
import { EmpleadoDisplayComponent } from "./components/empleado-display/empleado-display.component";
import { PaisAutocompleteComponent } from "./components/pais-autocomplete/pais-autocomplete.component";
import { ActividadAutocompleteComponent } from "./components/actividad-autocomplete/actividad-autocomplete.component";
import { EmpleadoAutocompleteComponent } from "./components/empleado-autocomplete/empleado-autocomplete.component";
import { TipoProyectoAutocompleteComponent } from "./components/tipo-proyecto-autocomplete/tipo-proyecto-autocomplete.component";
import { SociedadAutocompleteComponent } from "./components/sociedad-autocomplete/sociedad-autocomplete.component";
import { ZonaAutocompleteComponent } from "./components/zona-autocomplete/zona-autocomplete.component";
import { ImageUploadComponent } from "./components/image-upload/image-upload.component";
import { TipoRiesgoSocialAutocompleteComponent } from "./components/tipo-riesgo-social-autocomplete/tipo-riesgo-social-autocomplete.component";
import { PagoElectricidadAutocompleteComponent } from "./components/pago-electricidad-autocomplete/pago-electricidad-autocomplete.component";
import { ContratoElectricidadAutocompleteComponent } from "./components/contrato-electricidad-autocomplete/contrato-electricidad-autocomplete.component";
import { TitularidadEnergiaAutocompleteComponent } from "./components/titularidad-energia-autocomplete/titularidad-energia-autocomplete.component";
import { PagoCombustibleAutocompleteComponent } from "./components/pago-combustible-autocomplete/pago-combustible-autocomplete.component";
import { PagoCombustibleVehiculosAutocompleteComponent } from "./components/pago-combustible-vehiculos-autocomplete/pago-combustible-vehiculos-autocomplete.component";
import { TitularResiduosDesbasteAutocompleteComponent } from "./components/titular-residuos-desbaste-autocomplete/titular-residuos-desbaste-autocomplete.component";
import { TitularFangosAutocompleteComponent } from "./components/titular-fangos-autocomplete/titular-fangos-autocomplete.component";
import { TitularResiduosPeligrososAutocompleteComponent } from "./components/titular-residuos-peligrosos-autocomplete/titular-residuos-peligrosos-autocomplete.component";
import { TitularResiduosNoPeligrososAutocompleteComponent } from "./components/titular-residuos-no-peligrosos-autocomplete/titular-residuos-no-peligrosos-autocomplete.component";
import { AdquisicionReactivosAutocompleteComponent } from "./components/adquisicion-reactivos-autocomplete/adquisicion-reactivos-autocomplete.component";
import { ConsolidacionFinancieraAutocompleteComponent } from "./components/consolidacion-financiera-autocomplete/consolidacion-financiera-autocomplete.component";
import { UbicacionEspanaAutocompleteComponent } from "./components/ubicacion-espana-autocomplete/ubicacion-espana-autocomplete.component";
import { UbicacionSelectComponent } from "./components/ubicacion-select/ubicacion-select.component";

@NgModule({
	declarations: [
		UbicacionSelectComponent,
		PaisAutocompleteComponent,
		ActividadAutocompleteComponent,
		EmpleadoAutocompleteComponent,
		TipoProyectoAutocompleteComponent,
		SociedadAutocompleteComponent,
		ZonaAutocompleteComponent,
		ImageUploadComponent,
		TipoRiesgoSocialAutocompleteComponent,
		PagoElectricidadAutocompleteComponent,
		ContratoElectricidadAutocompleteComponent,
		TitularidadEnergiaAutocompleteComponent,
		PagoCombustibleAutocompleteComponent,
		PagoCombustibleVehiculosAutocompleteComponent,
		TitularResiduosDesbasteAutocompleteComponent,
		TitularFangosAutocompleteComponent,
		TitularResiduosPeligrososAutocompleteComponent,
		TitularResiduosNoPeligrososAutocompleteComponent,
		AdquisicionReactivosAutocompleteComponent,
		ConsolidacionFinancieraAutocompleteComponent,
		UbicacionEspanaAutocompleteComponent,
		UbicacionSelectComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatIconModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		TranslateModule,
		SharedModule,
		DsAutocompleteComponent,
		DsSelectComponent,
		DsToggleComponent,
		DsDateComponent,
		DsTextareaComponent,
		DsRadioComponent,
		DsCheckboxComponent,
		DsSliderComponent,
		EmpleadoAvatarComponent,
		EmpleadoDisplayComponent,
	],
	exports: [
		DsAutocompleteComponent,
		DsSelectComponent,
		DsToggleComponent,
		DsDateComponent,
		DsTextareaComponent,
		DsRadioComponent,
		DsCheckboxComponent,
		DsSliderComponent,
		EmpleadoAvatarComponent,
		EmpleadoDisplayComponent,
		PaisAutocompleteComponent,
		ActividadAutocompleteComponent,
		EmpleadoAutocompleteComponent,
		TipoProyectoAutocompleteComponent,
		SociedadAutocompleteComponent,
		ZonaAutocompleteComponent,
		ImageUploadComponent,
		TipoRiesgoSocialAutocompleteComponent,
		PagoElectricidadAutocompleteComponent,
		ContratoElectricidadAutocompleteComponent,
		TitularidadEnergiaAutocompleteComponent,
		PagoCombustibleAutocompleteComponent,
		PagoCombustibleVehiculosAutocompleteComponent,
		TitularResiduosDesbasteAutocompleteComponent,
		TitularFangosAutocompleteComponent,
		TitularResiduosPeligrososAutocompleteComponent,
		TitularResiduosNoPeligrososAutocompleteComponent,
		AdquisicionReactivosAutocompleteComponent,
		ConsolidacionFinancieraAutocompleteComponent,
		UbicacionEspanaAutocompleteComponent,
		UbicacionSelectComponent,
	],
})
export class FormControlsModule {}
